import { agencies } from './resources/agencies';
import { agents } from './resources/agents';
import { areas } from './resources/areas';
import { bookmarks } from './resources/bookmarks';
import { listings } from './resources/listings';
import { polygons } from './resources/polygons';
import { projects } from './resources/projects';
import { sold } from './resources/sold';
import { sources } from './resources/sources';
import { statistics } from './resources/statistics';

const factory = {
  agencies,
  agents,
  areas,
  bookmarks,
  listings,
  sold,
  polygons,
  projects,
  sources,
  statistics,
};

export { factory };
